export const SAVED_MODEL_URL = "/api/saved-model/";
export const GEN_MODEL_PIC_URL = "/api/gen-model-pic/";
export const TRAINING_HISTORY_URL = "/api/training-history/";
export const LEARNING_LOG_URL = "/api/learning-log/";
export const ACHIEVEMENT_URL = "/api/achievement/";

export const LOG_IN_URL = "/api/token/";
export const TOKEN_REFRESH_URL = "/api/token/refresh/";
export const USER_URL = "/api/user/";
export const PASSWORD_URL = "/api/password/";
export const FEEDBACK_URL = "/api/feedback/";
export const ANNOUNCE_MAIL_URL = "/api/announce-mail/";
export const CHAT_GPT_URL = "api/chat/question"
